import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { H1 } from '@hobs/components/Headings';
import objectPath from 'object-path';
import { GhostButton } from '@hobs/components/Buttons';
import { format } from '@hobs/utils/formatWithTimeZone';
import Icon from '@hobs/components/Icon';
import { Download } from '@hobs/utils/download';
import { exportReports } from '@hobs/actions/reports';
import Toast from '@hobs/components/Toast';
import Panel from '@hobs/components/Panel';

import './Reports.scss';

class Reports extends React.PureComponent {
  exportReports = async () => {
    const data = await this.props.exportReports();

    if (!data) {
      Toast.error('Could not get supplier reports');
    } else if (!objectPath.get(data, 'blob.payload', null) && data.success) {
      const date = format(new Date(), 'yyyy-MM-dd');
      Download(data.blob, `Report-${date}.xlsx`);
    } else {
      Toast.error(data.blob.payload.message);
    }
  };

  render() {
    const { t } = this.props;

    return (
      <div className="reports-view">
        <Panel>
          <div  className="reports-view--wrapper">
            <H1>{t('Supplier Reports')}</H1>
            <div className="reports-view--heading">
              <div className="reports-view--left">
                <GhostButton
                  iconLeft={<Icon icon="download" />}
                  onClick={this.exportReports}
                  className="reports-view--inline-buttons"
                >
                  {t('Export')}
                </GhostButton>
              </div>
            </div>
          </div>
        </Panel>
      </div>
    );
  }
}

Reports.propTypes = {
  t: PropTypes.func,
  exportReports: PropTypes.func
};

const mapDispatchToProps = {
  exportReports
};

export default connect(null, mapDispatchToProps)(withTranslation()(Reports));
